import { PropsWithChildren } from "react";
import { useSearch } from "./UseSearch";
import { SearchContext } from "./SearchContext";

export function SearchContextProvider(props: PropsWithChildren<unknown>): JSX.Element {
  const { children } = props;
  const search = useSearch();
  return <SearchContext.Provider value={search}>{children}</SearchContext.Provider>;
}
